<template>
  <div class="dict-list">
    <div
      v-for="x in dictList"
      :key="x.key"
      class="dict-item"
      :class="{ active: active === x.key }"
      @click="onClick(x)"
    >
      {{ x.label }}
    </div>
  </div>
</template>
<script lang="ts" setup>
const { $t } = useNuxtApp();

interface IProps {
  title?: string;
  modelValue?: string | number;
  name: string;
  hasAll?: boolean;
  allName?: string;
}

const props = withDefaults(defineProps<IProps>(), {
  hasAll: true,
});
const emit = defineEmits(['update:modelValue', 'change']);

const dictList = computed(() => {
  const list = useDicts(props.name);
  if (!list) {
    return [];
  }
  if (props.hasAll) {
    const all: DictItem = {
      key: 'all',
      label: props.allName || $t('quan-bu'),
    };
    return [all, ...list];
  }
  return list;
});

const active = computed({
  get: () => props.modelValue,
  set: v => {
    emit('update:modelValue', v);
    emit('change', v);
  },
});

const onClick = (data: DictItem) => {
  active.value = data.key;
};
</script>

<style lang="scss" scoped>
.dict-list {
  @apply flex items-center text-font-60;
  .dict-item {
    @apply cursor-pointer hover:text-font-1;

    &.active {
      @apply font-semibold text-font-1;
    }
  }
}
</style>
